export default "__VITE_ASSET__BNUQQ8uJ__"